



















































































































































import { Component, Mixins } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';
import { STATUSES, TYPES, BOOKING_PURPOSES } from '@/constants/booking';
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from '@/constants/booking_candidate';
import BodyMapMixins from '@/mixins/BodyMapMixins';
import TransitionMixins from '@/mixins/TransitionMixins';

@Component({
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('Booking', {
      booking: 'booking',
    }),
    ...mapState('RiskProfile', {
      riskProfile: 'riskProfile',
      bodyParts: 'bodyParts', // is used in BodyMapMixins
    }),
    ...mapGetters('RiskProfile', {
      enabledQuestionGroups: 'enabledQuestionGroups',
      bodyPartPreviewItems: 'bodyPartPreviewItems',
    }),
  },
})
export default class BookingReadReview extends Mixins(
  BodyMapMixins,
  TransitionMixins
) {
  booking!: Model;

  types = TYPES;
  statuses = STATUSES;
  purposes = BOOKING_PURPOSES;
  showPreview = false;
  questionGroupDescription =
    'Here is the list of the question groups the individual will complete which will provide the relevant information in their report.';
  cancelDialog = false;

  get cancellable() {
    return (
      [STATUSES.STATUS_PAID.key, STATUSES.STATUS_ONGOING.key].includes(
        this.booking.status as string
      ) &&
      this.booking.booking_candidates.filter((candidate) =>
        [
          BOOKING_CANDIDATE_STATUSES.STATUS_CANDIDATE_INPUTTING.key,
          BOOKING_CANDIDATE_STATUSES.STATUS_AWAIT_RESULT.key,
          BOOKING_CANDIDATE_STATUSES.STATUS_COMPLETED.key,
        ].includes(candidate.status)
      ).length == 0
    );
  }

  cancel() {
    this.$emit('cancel');
  }
}
